"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageFile = exports.PublishMethod = exports.CountPrecision = exports.CURRENT_PACKAGE_FILE_SCHEMA_URL = void 0;
exports.CURRENT_PACKAGE_FILE_SCHEMA_URL = "https://datapm.io/docs/package-file-schema-v0.32.1.json";
var CountPrecision;
(function (CountPrecision) {
    CountPrecision["EXACT"] = "EXACT";
    CountPrecision["APPROXIMATE"] = "APPROXIMATE";
    CountPrecision["GREATER_THAN"] = "GREATER_THAN";
})(CountPrecision = exports.CountPrecision || (exports.CountPrecision = {}));
var PublishMethod;
(function (PublishMethod) {
    PublishMethod["SCHEMA_ONLY"] = "SCHEMA_ONLY";
    PublishMethod["SCHEMA_AND_DATA"] = "SCHEMA_AND_DATA";
    PublishMethod["SCHEMA_PROXY_DATA"] = "SCHEMA_PROXY_DATA";
})(PublishMethod = exports.PublishMethod || (exports.PublishMethod = {}));
class PackageFile {
    constructor() {
        this.$schema = exports.CURRENT_PACKAGE_FILE_SCHEMA_URL;
    }
}
exports.PackageFile = PackageFile;
//# sourceMappingURL=PackageFile-v0.32.1.js.map